import { createModel } from '@rematch/core';
import { messageService } from 'src/config/rootService';
import { RootModel } from 'src/config/rootStore';
import { MeditationNode, ProgramNode } from 'src/generated/webapp_gql';
import { messagingClient } from '../messagingClient';
import type { MessageResource } from '../services/MessageService';

export type MessageResourcesState = {
    programs?: Record<number, Partial<ProgramNode>> | null;
    meditations?: Record<number, Partial<MeditationNode>> | null;
};

const defaultState: MessageResourcesState = {
    programs: null,
    meditations: null,
};

export const messaging = createModel<RootModel>()({
    state: defaultState,
    reducers: {
        setResources: (_, payload: MessageResource): MessageResourcesState => {
            const meditations: Record<number, MeditationNode> | undefined =
                payload?.meditations?.reduce((acc, m) => {
                    acc[m.id] = m;
                    return acc;
                }, {});

            const programs: Record<number, ProgramNode> | undefined = payload?.programs?.reduce(
                (acc, p) => {
                    acc[p.id] = p;
                    return acc;
                },
                {},
            );
            return { programs, meditations };
        },
    },
    effects: dispatch => ({
        async getMessageResources(): Promise<void> {
            const data = await messageService.fetchResources();
            if (data) {
                dispatch.messaging.setResources(data);
            }
        },
        setActiveUserUuid(uuid: string): void {
            messagingClient.setActiveUserUuid(uuid);
        },
        clearActiveUserUuid(): void {
            messagingClient.setActiveUserUuid(null);
        },
    }),
});
